import { AdjustFontSizeToFitContent } from "@newsela/angelou";
import { type SourceAnalysisOrganizerFormData } from "@/types/models/Exportables.interface";
import { TemplateTextArea } from "@/components/AIComponents/ExportablesModal/templates/components/TemplateTextArea";
import {
  guideLabelCell,
  guideRow,
  textAreaCss,
  textAreaCounterCss,
} from "./SourceAnalysisOrganizer.styles";

interface SourceAnalysisRowProps {
  field: keyof SourceAnalysisOrganizerFormData;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  templateId: string;
  value: string | number;
}

const CUSTOM_INPUT_MAX_LENGTH = 134;

const SourceAnalysisRow = ({
  field,
  label,
  onChange,
  templateId,
  value,
}: SourceAnalysisRowProps) => {
  const fieldName = field.toLowerCase().replace(/_\s/g, "-");
  const id = `${fieldName}-${templateId}`;
  const qaSelector = `exportables-source-analysis-${fieldName}`;
  const trimmedValue = `${value}`.substring(0, CUSTOM_INPUT_MAX_LENGTH) ?? "";

  return (
    <TemplateTextArea
      value={trimmedValue}
      maxLength={CUSTOM_INPUT_MAX_LENGTH}
      css={guideRow}
    >
      <div css={guideLabelCell}>
        <div>
          <AdjustFontSizeToFitContent>
            <label htmlFor={id}>{label}</label>
          </AdjustFontSizeToFitContent>
        </div>
      </div>
      <TemplateTextArea.TextArea
        id={id}
        data-qa-selector={qaSelector}
        onChange={onChange}
        css={textAreaCss}
      />
      <TemplateTextArea.CharacterCount css={textAreaCounterCss} />
    </TemplateTextArea>
  );
};

export default SourceAnalysisRow;
